if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"inboxApp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^([36]91|(75|80|9)6|34|543|72|870)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}